import { createContext } from 'react';

export type SpinnerContextShape = {
  isSpinnerVisible: boolean;
  showSpinner: () => void;
  hideSpinner: () => void;
};

export const SpinnerContext = createContext<SpinnerContextShape>(
  {} as SpinnerContextShape,
);
